import React from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { Sign } from '../../data/signs';
interface SignSolucionProps {
  sign: Sign;
}
export function SignSolucion({
  sign
}: SignSolucionProps) {
  const {
    nucleoTitle,
    nucleoDescription
  } = sign.content;
  return <section className="py-20 px-6 bg-transparent" data-id="element-461">
      <div className="container mx-auto max-w-4xl" data-id="element-462">
        <AnimatedSection data-id="element-463">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center mb-8" style={{
          color: sign.colors.accent,
          textShadow: `0 0 40px ${sign.colors.primary}60`
        }} data-id="element-464">
            {nucleoTitle}
          </h2>
        </AnimatedSection>

        <AnimatedSection delay={0.3} data-id="element-465">
          <p className="text-gray-200 text-lg leading-relaxed text-center max-w-3xl mx-auto" data-id="element-466">
            {nucleoDescription}
          </p>
        </AnimatedSection>
      </div>
    </section>;
}